module.exports = __webpack_public_path__ + "img/3 steps (1) (2).52a9de37.svg";